// removed by extract-text-webpack-plugin
module.exports = {"video-overlay":"_32tmUH0RnHaHn-RTsT4lo1","videoOverlay":"_32tmUH0RnHaHn-RTsT4lo1"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/storydoc/book/overlays/videoOverlay.css
// module id = 395
// module chunks = 0